/**
 * Channel Detail Save Billing Policy
 * 
 * Triggered when billing entity save is initiated.
 * Calls backend API to update channel billing entity.
 */

import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { ChannelsState } from '../state';
import { ChannelsCommand } from '../commands';

export const createChannelDetailSaveBillingPolicy = (
  backend: ClientLibraryType
): Policy<ChannelsState, ChannelsCommand> => ({
  name: 'channel-detail-save-billing',

  shouldReact: ( prev, next ) => {
    // Trigger when savingBilling changes from false to true
    return !prev.channelDetail.loading.savingBilling && next.channelDetail.loading.savingBilling;
  },

  onStateChange: async ({ next, ctx }) => {
    const { dispatch } = ctx;
    
    if ( next.channelDetail.mode.type !== 'view' ) return;
    
const integrationId = next.channelDetail.mode.integrationId;
   const channel = next.salesChannels[integrationId];
    const newBillingEntityId = next.channelDetail.billingEntityEdit.tempValue;
    
    if ( !channel ) return;
    
    // Skip if value didn't actually change
    const prevId = channel.billingEntityId ?? null;
    if ( newBillingEntityId === prevId ) {
      dispatch(
        { type: 'integrations/channels/detail/billingEntity/cancel', payload: {}},
        { source: 'policy' }
      );
      dispatch(
        { type: 'integrations/channels/detail/loading/setSavingBilling', payload: { isLoading: false }},
        { source: 'policy' }
      );
      return;
    }

    // eslint-disable-next-line teselly/no-swallowed-command-dispatch -- console.error operator log only + documented TODO to add an error notification; no user surface yet (TV1-2010 waiver, not a rethrow).
    try {
      await backend.commands.UpdateSystemIntegrationConfiguration({
        id: channel.id,
        body: {
          billingEntityId: newBillingEntityId!,
          id: channel.id,
          accountId: channel.accountId,
          connectorId: channel.connectorId,
          integrationUserId: channel.integrationUserId
        }
      });
      
      // Success - close edit mode
      dispatch(
        { type: 'integrations/channels/detail/billingEntity/cancel', payload: {}},
        { source: 'policy' }
      );
    } catch ( error ) {
      console.error( 'Error saving billing entity:', error );
      // TODO: Show error notification
    } finally {
      dispatch(
        { type: 'integrations/channels/detail/loading/setSavingBilling', payload: { isLoading: false }},
        { source: 'policy' }
      );
    }
  }
});
